import { KEY_CODES } from 'consts/consts';
import { CARD_BUTTON } from 'consts/dataQaConst.js';
import { BUTTON_SIZE, BUTTON_TYPE, CARD_ACTION_TYPE } from 'consts/enum';
import { generateBtnOnClickFnc, removeElement, setCustomTagHTML } from 'helpers/helpers';
import cardImg from 'icons/cardImg.svg';
import { phone } from 'icons/phone';
import { url } from 'icons/url';
import { Button } from 'ui/button/button.module';
import { Dropdown } from 'ui/dropdown/dropdown.module';
import { Popover } from 'ui/popover/popover.module';
import { cardOptions } from './card.model';
import { CardTemplate } from './card.template';

export class Card {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initComponents();
		this.initEventHandlers();
		this.initPopover();
	}

	initData(propData) {
		this.data = cardOptions;
		this.setter(propData);
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		wrapper.innerHTML = CardTemplate(this.data);

		this.html = wrapper.children[0];
	}

	initComponents() {
		const { buttons, buttonStyle = '', buttonType = BUTTON_TYPE.SECONDARY, dropdowns } = this.data;
		const fragment = document.createDocumentFragment();
		const dropDownsfragment = document.createDocumentFragment();
		let dropdownArray = [];

		if (dropdowns?.title && dropdowns?.payload) {
			if (dropdowns.title) {
				const dropdownsVal = JSON.parse(dropdowns.title) || [];
				dropdownArray = [...dropdownsVal];
			}
		}

		dropdownArray?.length &&
			dropdownArray.map((dropdown, index) => {
				const { label, options } = dropdown;
				dropDownsfragment.appendChild(
					new Dropdown({
						id: this.data.id,
						msgId: this.data.msgId,
						title: label,
						payload: dropdowns?.payload,
						options,
						name: `dropdown-${index}`,
					}).render()
				);
			});

		buttons &&
			buttons.length &&
			buttons.map((button) => {
				let { title } = button;
				const actionType = button.type?.toUpperCase?.();
				if (actionType === CARD_ACTION_TYPE.PHONE_NUMBER) {
					title = `<span class="engt-btn-start-enhancer">${phone()}</span>${title}`;
				} else if (actionType === CARD_ACTION_TYPE.WEB_URL) {
					title = `<span class="engt-btn-start-enhancer">${url()}</span>${title}`;
				}

				fragment.appendChild(
					new Button({
						style: `${buttonStyle}`,
						size: BUTTON_SIZE.SMALL,
						type: buttonType,
						label: title,
						applyOnHover: true,
						tabIndex: 0,
						dataQa: CARD_BUTTON,
						onClick: generateBtnOnClickFnc({
							...button,
							dropdowns: { data: dropdownArray, payload: dropdowns?.payload },
							index: this.data.id,
							msgId: `${this.data.msgId}-${this.data.id}-dropdown`,
							otherChannelsData: this.data.otherChannelsData,
						}),
					}).render()
				);
			});

		if (dropdownArray?.length) {
			setCustomTagHTML(this.html.querySelector('dropdowns'), dropDownsfragment);
		} else {
			removeElement(this.html.querySelector('.engt-card-dropdowns'));
		}

		if (buttons?.length) {
			setCustomTagHTML(this.html.querySelector('buttons'), fragment);
		} else {
			removeElement(this.html.querySelector('.engt-card-btns'));
		}
	}

	initEventHandlers() {
		const { onClick, onImgClick } = this.data;
		const clickableDiv = this.html.querySelector('.engt-card-clickable');
		const imgDiv = this.html.querySelector('img');
		const onKeydownImg = function (e) {
			const keyCode = e.which ? e.which : e.keyCode;
			if (keyCode === KEY_CODES.ENTER) {
				onImgClick(e);
			}
		};

		if (onClick && clickableDiv) {
			clickableDiv.addEventListener('click', onClick);
			clickableDiv.addEventListener('keydown', (e) => {
				const keyCode = e.which ? e.which : e.keyCode;
				if (keyCode === KEY_CODES.ENTER) {
					onClick();
				}
			});
			clickableDiv.style.cursor = 'pointer';
		}
		if (onImgClick && imgDiv) {
			imgDiv.setAttribute('tabindex', 0);
			imgDiv.addEventListener('click', onImgClick);
			imgDiv.addEventListener('keydown', onKeydownImg);
		}
		if (imgDiv) {
			imgDiv.addEventListener('error', function () {
				this.src = cardImg;
				this.removeEventListener('click', onImgClick);
				this.removeEventListener('keydown', onKeydownImg);
			});
		}
	}

	initPopover() {
		const { readMoreColor = '', popoverRole } = this.data;
		const ref = this;
		const titleDiv = this.html.querySelector('.title');
		const descriptionDiv = this.html.querySelector('.description');

		if (descriptionDiv) {
			const popoverContent = descriptionDiv.cloneNode(true);
			new Popover({
				parent: descriptionDiv,
				child: popoverContent,
				role: popoverRole,
				textBgColor: readMoreColor,
				onClick() {
					ref.html.style.height = '100%';
				},
			}).render();
		}
		if (titleDiv) {
			const popoverContent = titleDiv.cloneNode(true);
			new Popover({
				parent: titleDiv,
				child: popoverContent,
				role: popoverRole,
				textBgColor: readMoreColor,
				onClick() {
					ref.html.style.height = '100%';
				},
			}).render();
		}
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
